import { CommonActionType } from '../common/common-actions';
import { CommonLabParentResourceActionType } from '../lab-parent-resource/lab-parent-resource-actions';
export const GalleryImageActionType = {
    ...CommonActionType,
    ...CommonLabParentResourceActionType,
    LIST_GALLERY_IMAGES: 'LIST_GALLERY_IMAGES',
    LIST_GALLERY_IMAGES_SUCCESS: 'LIST_GALLERY_IMAGES_SUCCESS',
    LIST_GALLERY_IMAGES_ERROR: 'LIST_GALLERY_IMAGES_ERROR',
};
